import { KycCurrentStatus, type KycResponse } from '@repo/api-kit/queries/due-diligence/kyc';
import { memberships } from '@repo/api-kit/memberships';
import { isKycRequired } from './is-kyc-required';
import { isKycSubmitted } from './is-kyc-submitted';
import { isPersonalInfoProvided } from './is-personal-info-provided';

type ApiKycStatus = memberships.firstparty.v3.ApiKycStatus;
const ApiKycStatus = memberships.firstparty.v3.ApiKycStatus;

export interface LegacyKycFields {
  kycStatus: ApiKycStatus;
  kycRequired: boolean;
  kycSubmitted: boolean;
  personalInfoProvided: boolean;
}

function mapKycCurrentStatus(status: keyof typeof KycCurrentStatus): ApiKycStatus {
  if (status === KycCurrentStatus.KYC_CURRENT_STATUS_UNSPECIFIED) {
    return ApiKycStatus.KYC_STATUS_UNSPECIFIED;
  }
  return status;
}

export function mapKycAcceptanceToLegacy(kycInfo?: KycResponse | null): LegacyKycFields | null {
  if (!kycInfo) return null;

  return {
    kycStatus: mapKycCurrentStatus(kycInfo.kycCurrentStatus),
    kycRequired: isKycRequired(kycInfo),
    kycSubmitted: isKycSubmitted(kycInfo),
    personalInfoProvided: isPersonalInfoProvided(kycInfo),
  };
}
